import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { QuoteDataCaptureService, CommonUtilityService, SERVICE_END_POINT, LoaderService } from '../../../../../shared';
import { ActivatedRoute } from '@angular/router';
import { AlertModal } from '../../../../../model/alert';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/state/app.state';
import * as quoteResultActions from '../../../../../store/actions/quote-result.actions';
import { Partialproductquote } from 'src/app/model/partialproductquote';
import * as RefNoActions from '../../../../../store/actions/reference-number.actions';
import * as BeforeStartActions from '../../../../../store/actions/before-start.actions';
import * as PersDetailsActions from '../../../../../store/actions/personal-details.actions';
import * as UserDataConfig from '../../../config/user-data.config';
import * as BeforeYouStartActions from '../../../../../store/actions/before-start.actions';
import * as DependantDetailsActions from '../../../../../store/actions/dependant-details.actions';
import * as UserDataConfigUserDetail from '../../../../user-details/config/user-data.config';
import * as YourPensionActions from '../../../../../store/actions/your-pension.actions';
import { YourPension } from '../../../../../model/ngrx/your-pension.model';
import { ProductChoice } from '../../../../../model/ngrx/Product-Choice.model';
import * as ProductChoiceActions from '../../../../../store/actions/product-choice.actions';
import { DependantDetails } from '../../../../../model/ngrx/dependant-details.model';
import * as DepDetailsActions from '../../../../../store/actions/dependant-details.actions';
import * as ReqQuoteCalcActions from '../../../../../store/actions/request-quote-calculation.actions';
import * as resDataCalculationActions from '../../../../../store/actions/response-quote-calculation.actions';
import * as BreadCrumDataConfig from '../../../../../common-components/config/user-data.config';
import * as resDataCaptureActions from '../../../../../store/actions/response-quote-datacapture.actions';
import * as QuotePlaybackRiskWarningActions from '../../../../../store/actions/playback-risk-warnings.actions';
import { UtilService } from '../../../../../shared';
import { UnderWritingData, AnnuitantMedicalConditions } from 'src/app/pages/medical-underwriting/model/lifestyle.post.model';
import * as LifeStyleActions from '../../../../medical-underwriting/store/actions/lifestyle.action';
import { Selectedproductquote } from 'src/app/model/selectedproductquote';
import { SelectedProductQuoteFTRP } from 'src/app/model/selectedProductQuoteFTRP';
import { SelectedProductQuoteCORP } from 'src/app/model/selectedProductQuoteCORP';
import { Subscription, Observable, of } from 'rxjs/';
import { OutputDetailsService, ButtonService } from 'src/app/shared';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ApplicationDataCaptureService } from 'src/app/shared/services/api-services/application-datacapture.service';
import * as HealthRecordsActions from '../../../../../store/actions/health-records.actions';
import * as beneficiaryDetailsActions from '../../../../../store/actions/beneficiary-details.actions';
import * as ClearToApplyActions from '../../../../../store/actions/clear-to-apply.actions';
import * as DepHealthRecordsActions from '../../../../../store/actions/dep-health-records.actions';
import * as paymentDetailsActions from '../../../../../store/actions/payment-details.actions';
import * as yourDependantDetailsActions from '../../../../../store/actions/your-dependant-details.actions';
import * as yourPersonalDetailsActions from '../../../../../store/actions/your-personal-details.actions';
import * as YourPensionSavings from '../../../../../store/actions/your-pension-savings.actions';
import * as yourProductApplicationActions from '../../../../../store/actions/your-product-application.actions';
import * as loggedInDetailActions from '../../../../../store/actions/loggedin-detail.action';
import { AnalyticsService } from 'src/app/shared/services/api-services/analytics.service';
import { SelectedGMPQuote } from 'src/app/model/selectedGMPQuote';
import { quoteLevelConstants } from '../../../../../shared/constants/attribute-values.constants';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import * as YourLumpSumActions from '../../../../../store/actions/your-lump-sum-allowances.actions';
@Component({
  selector: 'app-your-save-quote',
  templateUrl: './your-save-quote.component.html',
  styleUrls: ['./your-save-quote.component.scss']
})
export class YourSaveQuoteComponent implements OnInit, OnDestroy {
  public yourSavedQuoteForm: UntypedFormGroup;
  public guaranteedQuoteResultArray = [];
  public partialApplicationsResultArray: Selectedproductquote[] = [];
  public submittedApplicationsResultArray: Selectedproductquote[] = [];
  public indicativeQuoteResultArray: Selectedproductquote[] = [];
  protected guaranteedQuoteResultApi: any[];
  protected partialQuoteResultApi: any[];
  protected partialApplicationArrayApi: any[];
  protected sumbittedApplicationArrayApi: any[];
  protected indicativeQuoteResultApi: any[];
  public invalidQuoteResultArrayApi: any[];
  protected expiredQuoteResultArrayApi: any[];
  public invalidGuaranteedQuoteArray: Selectedproductquote[];
  public invalidIndicativeQuoteArray: Selectedproductquote[];
  public partialQuoteResultArray: Partialproductquote[] = [];
  public contentData;
  public quote;
  screenName;
  public expiredQuoteResultArray: Selectedproductquote[] = [];
  protected loginDetail: any;
  loadingFlag: boolean = false;
  loadingPDFFlag: boolean = false;
  applyFlag: boolean = false;
  displayAlert = false;
  public pdfUrlArray;
  public application;
  protected cmsDataProductChoice;
  public displayCancelAlert = false;
  public displayResumeAlert = false;
  public displayAlertRequote = false;
  public customerId: string;
  public applicationId: string;
  protected selectedquoteRefNo;
  protected resposeJsonLoggedInDetailStore: any;
  protected ReferenceNoStore: any;
  public cancelApplicationAlertModalConfig: AlertModal;
  public resumeApplicationAlertModalConfig: AlertModal;
  public requotealertModalConfig: AlertModal;
  public guidanceAndAdviceModalConfig: AlertModal;
  protected sourcesCvt = UserDataConfig.ElementsConfig.sourcesListCvt;
  protected requoteRefNum: string;
  private subscriptionLogin: Subscription;
  private InvalidateAllQuote = false;
  private viewQuoteFlag = false;
  private CMSData;
  private CMSDataCancelApp;
  private CMSDataQuoteExp;
  private CMSDataNewQuoteData;
  private subscripSaveProgress: Subscription;
  private subscriptn: Subscription;
  public showPopupGuidanceANdAdvice = false;
  private quoteReferenceListing = [];
  private internalReferenceDCJListing = [];
  private applicationReferenceListing = [];
  constructor(private fb: UntypedFormBuilder, private router: Router,
    private analyticsService: AnalyticsService,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private buttonService: ButtonService,
    private outputDetailsService: OutputDetailsService,
    private applicationDataCaptureService: ApplicationDataCaptureService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private utilService: UtilService,
    private loaderService: LoaderService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.yourSavedQuotes;
    this.cmsDataProductChoice = this.activatedRoute.snapshot.data.contentData.productChoice;
    this.subscriptionLogin = store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.resposeJsonLoggedInDetailStore = res[0];
        this.customerId = this.resposeJsonLoggedInDetailStore.customer.customerId;
        if (res[0]['showWarning'] === 'N') {
          this.InvalidateAllQuote = true;
        }
      }
    });
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });
    this.activatedRoute.data
      .subscribe((data) => {
        this.CMSData = data.cmsJson['saveQuotes'];
        this.CMSDataCancelApp = data.cmsJson['cancelApp'];
        this.CMSDataQuoteExp = data.cmsJson['quoteExpiry'];
        this.CMSDataNewQuoteData = data.cmsJson['newQuote'];
      });
  }
  ngOnInit() {
    this.subscripSaveProgress = this.quoteDatacaptureService.invokeSaveFunction.subscribe((res) => {
      this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
    });

    // If user is registered and logged in update registrationStatus to true
    // else user is not registered, already registrationStatus is false

    this.loginDetail = {...this.loginDetail, customer: {...this.loginDetail.customer, registrationStatus: true, reviewStatus: false} };
    this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
    this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(this.loginDetail));

    this.GetCMSDataServiceMapper();
    this.GetCMSDataServiceMapperCancelApp();
    this.GetCMSDataServiceMapperAppQuoteExpiry();
    this.GetCMSDataServiceMapperNewQuoteModal();
    this.GetCMSGuidanceAndAdviceModal();
    this.utilService.popUpGuidanceAndAdvice$.subscribe(res => {
      if (res == "true") {
        this.showPopupGuidanceANdAdvice = true;
      }
    })
    this.cancelApplicationAlertModalConfig = this.contentData.modalConfigCancelApplication;
    this.resumeApplicationAlertModalConfig = this.contentData.modalConfigResumeApplication;
    this.requotealertModalConfig = this.contentData.modalConfigReQuote;
    this.guidanceAndAdviceModalConfig = this.contentData.GuidanceANdAdviceModalConfig;
    this.yourSavedQuoteForm = this.fb.group({
    });
    this.getLoadData();
    this.store.dispatch(new LifeStyleActions.RemoveLifestyleResult(0));
    this.store.dispatch(new BeforeYouStartActions.RemoveBeforeStart(0));
    this.store.dispatch(new DependantDetailsActions.RemoveDependantDetails(0));
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    this.store.dispatch(new QuotePlaybackRiskWarningActions.RemoveQuotePlaybackRiskWarning(0));
    this.store.dispatch(new ProductChoiceActions.RemoveProductChoice(0));
    this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
    this.store.dispatch(new ReqQuoteCalcActions.RemoveReqQuoteCalculation(0));
    this.store.dispatch(new resDataCalculationActions.RemoveQuoteCalculation(0));
    this.store.dispatch(new resDataCaptureActions.RemoveQuoteCapture(0));
    this.store.dispatch(new YourPensionActions.RemoveYourPension(0));
    this.store.dispatch(new HealthRecordsActions.RemoveHealthRecords(0));
    this.store.dispatch(new beneficiaryDetailsActions.RemoveBeneficiaryDetails(0));
    this.store.dispatch(new ClearToApplyActions.RemoveClearToApply(0));
    this.store.dispatch(new YourLumpSumActions.RemoveYourLumpSumAllowances(0));
    this.store.dispatch(new DepHealthRecordsActions.RemoveDepHealthRecords(0));
    this.store.dispatch(new paymentDetailsActions.RemovePaymentDetails(0));
    this.store.dispatch(new yourDependantDetailsActions.RemoveYourDependantDetails(0));
    this.store.dispatch(new yourPersonalDetailsActions.RemoveYourPersonalDetails(0));
    this.store.dispatch(new yourProductApplicationActions.RemoveYourProductApplication(0));
    this.store.dispatch(new YourPensionSavings.RemovePensionSavings(0));
    this.applicationDataCaptureService.screenName = '';


    // document.addEventListener('pdfDownload', this.handleCustomEvent.bind(this));
    
  }
  getLoadData() {
    if (this.customerId !== undefined) {
      this.loaderService.handleSpinnerFlag({ show: true, onlyBackgroundFlag: false, Message: 'Loading', opacity: .4 });
      this.quoteDatacaptureService.getAllGuaranteedQuote(this.customerId).subscribe(res => {
        this.data(res);
        this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 });
      },
        err => this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: .4 })
      );
    }
  }
  data(res) {

    this.guaranteedQuoteResultApi = res['guaranteedQuotes'];
    this.partialQuoteResultApi = res['partialQuotes'];
    this.indicativeQuoteResultApi = (res['indicativeQuotes']) ? res['indicativeQuotes'] : [];
    this.invalidQuoteResultArrayApi = res['invalidQuotes'] ? res['invalidQuotes'] : [];
    this.expiredQuoteResultArrayApi = res['expiredQuotes'] ? res['expiredQuotes'] : [];
    this.partialApplicationArrayApi = res['applicationsInProgress'] ? res['applicationsInProgress'] : [];
    this.sumbittedApplicationArrayApi = res['applicationsSubmitted'] ? res['applicationsSubmitted'] : [];
    this.formatPartialToObject();
    this.guaranteedQuoteResultArray = this.formatGuaranteedToObject(this.guaranteedQuoteResultApi);
    this.indicativeQuoteResultArray = this.formatIndicativeToObject(this.indicativeQuoteResultApi);
    // this.invalidIndicativeQuoteArray = this.formatIndicativeToObject(this.invalidQuoteResultArrayApi.filter(q => q['indicative'] === 'Y'));
    // this.invalidGuaranteedQuoteArray = this.formatGuaranteedToObject(this.invalidQuoteResultArrayApi.filter(q => q['indicative'] === 'N'));
    this.expiredQuoteResultArray = this.formatGuaranteedToObject(this.expiredQuoteResultArrayApi);
    this.partialApplicationsResultArray = this.formatGuaranteedToObjectApplication(this.partialApplicationArrayApi);
    this.submittedApplicationsResultArray = this.formatGuaranteedToObjectApplication(this.sumbittedApplicationArrayApi);
    this.invalidGuaranteedQuoteArray = this.formatGuaranteedToObject(this.invalidQuoteResultArrayApi);
    this.analyticsService.orderTrack({'quoteReferenceListing':this.quoteReferenceListing,'internalReferenceDCJListing': this.internalReferenceDCJListing, 'applicationReferenceListing': this.applicationReferenceListing})
  }

  formatGuaranteedToObject(QuoteResultApi: any[]): Selectedproductquote[] {
    let convertApiToObjectArray: any[] = [];
    QuoteResultApi.forEach(element => {
      const taxFreeCashAmount = element.totalTaxFreeCashAmount || 0;
      const extTaxFreeCashAmount = element.totalExtTaxFreeCashAmount || 0;
      if(element.applicationId && this.applicationReferenceListing.includes(element.applicationId) == false) {
        this.applicationReferenceListing.push(element.applicationId)
      }
      
      if(element['quoteRefNo'] && this.internalReferenceDCJListing.includes(element['quoteRefNo']) == false) {
        this.internalReferenceDCJListing.push(element['quoteRefNo'])
      }
      if(element['padsRefNo'] && this.quoteReferenceListing.includes(element['padsRefNo']) == false) {
        this.quoteReferenceListing.push(element['padsRefNo'])
      }
      if (element.isGMP === quoteLevelConstants.radioToggleYesNo.yes) {
        const selectedGMP = new SelectedGMPQuote();
        selectedGMP.isGMP = element.isGMP;
        selectedGMP.quoteRefNo = element.quoteRefNo;
        selectedGMP.padsRefNo = element.padsRefNo;
        selectedGMP.monthlyIncome = element.annualIncome ? element.annualIncome / 12 : 0;
        selectedGMP.annualIncome = element.annualIncome;
        selectedGMP.quoteExpiry = element.quoteExpiry;
        selectedGMP.pensionFund = parseFloat(element.pensionFund).toFixed(2);
        selectedGMP.startDate = element.startDate;
        selectedGMP.income = CommonUtilityService.formatIncome(element.paymentFrequency, element.paymentAdvance);
        selectedGMP.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
        selectedGMP.taxFreeCashAmountPercent = element.taxFreeCashAmountPercent;
        selectedGMP.requoteInd = element.requoteInd;
        selectedGMP.selectedProduct = element.product;
        selectedGMP.productOptions = element.productOptions;
        selectedGMP.indicative = element.indicative;
        selectedGMP.paymentFrequency = element.paymentFrequency;
        selectedGMP.fundingSource = element.source;
        convertApiToObjectArray.push(selectedGMP);
      } else {
        if (element && element.product === 'C') {
          const selectedproductquote = new Selectedproductquote();
          selectedproductquote.pensionFund = (this.isGARCheck(element.garIndicator)) ?
            element.totalFund : parseFloat(element.netAmount).toFixed(2);
          selectedproductquote.productOptions = element.productOptions;
          selectedproductquote.startDate = element.startDate;
          selectedproductquote.income = CommonUtilityService.formatIncome(element.paymentFrequency, element.paymentAdvance);
          selectedproductquote.incomeIncrease = CommonUtilityService.formatIncomeIncrease(element.escalationType, element.escalationRate);
          selectedproductquote.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
          selectedproductquote.incomeDependent = element.secondLifePensionPercentage ? element.secondLifePensionPercentage : 0;
          selectedproductquote.guaranteedTerm = element.guaranteedTerm ? element.guaranteedTerm : 0;
          selectedproductquote.guarantedPaymentPeriod = CommonUtilityService.formatGuarantedPaymentPeriod(element.guaranteedTerm);
          selectedproductquote.valueProtection = element.vpPercentage;
          selectedproductquote.valueProtectionAmount = element.vpAmount;
          selectedproductquote.quoteExpiry = element.quoteExpiry;
          selectedproductquote.monthlyIncome = element.annualIncome ? element.annualIncome / 12 : 0;
          selectedproductquote.annualIncome = element.annualIncome;
          selectedproductquote.padsRefNo = element.padsRefNo;
          selectedproductquote.paymentFrequency = element.paymentFrequency;
          selectedproductquote.selectedProduct = element.product;
          selectedproductquote.quoteRefNo = element.quoteRefNo;
          selectedproductquote.requoteInd = element.requoteInd;
          selectedproductquote.applyQuoteInd = element.applyQuoteInd;
          selectedproductquote.indicative = element.indicative;
          selectedproductquote.garIndicator = element.garIndicator;
          selectedproductquote.taxFreeCashAmountPercent = element.taxFreeCashAmountPercent;
          selectedproductquote.vpIndicator = element.vpIndicator;
          selectedproductquote.fundingSource = element.source;
          //this.guaranteedQuoteResultArray.push(selectedproductquote);
          convertApiToObjectArray.push(selectedproductquote);
        } else if (element && element.product === 'H') {
          const selectedProductQuoteFTRP = new SelectedProductQuoteFTRP();
          selectedProductQuoteFTRP.pensionFund = parseFloat(element.netAmount).toFixed(2);
          selectedProductQuoteFTRP.productOptions = element.productOptions;
          selectedProductQuoteFTRP.startDate = element.startDate;
          selectedProductQuoteFTRP.income = CommonUtilityService.formatIncome(element.paymentFrequency, element.paymentAdvance);
          selectedProductQuoteFTRP.incomeIncrease = CommonUtilityService.formatIncomeIncrease(element.escalationType, element.escalationRate);
          selectedProductQuoteFTRP.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
          selectedProductQuoteFTRP.incomeDependent = element.secondLifePensionPercentage ? element.secondLifePensionPercentage : 0;
          selectedProductQuoteFTRP.guaranteedTerm = element.guaranteedTerm ? element.guaranteedTerm : 0;
          selectedProductQuoteFTRP.guaranteedTermIndicator = element.guaranteedTermIndicator ? element.guaranteedTermIndicator : null;
          selectedProductQuoteFTRP.guarantedPaymentPeriod = CommonUtilityService.formatGuarantedPaymentPeriod(element.guaranteedTerm);
          selectedProductQuoteFTRP.valueProtection = element.vpPercentage;
          selectedProductQuoteFTRP.valueProtectionAmount = element.vpAmount;
          selectedProductQuoteFTRP.quoteExpiry = element.quoteExpiry;
          selectedProductQuoteFTRP.monthlyIncome = element.annuitantPension ? element.annuitantPension : 0;
          selectedProductQuoteFTRP.annualIncome = element.annualIncome;
          selectedProductQuoteFTRP.padsRefNo = element.padsRefNo;
          selectedProductQuoteFTRP.paymentFrequency = element.paymentFrequency;
          selectedProductQuoteFTRP.selectedProduct = element.product;
          selectedProductQuoteFTRP.quoteRefNo = element.quoteRefNo;
          selectedProductQuoteFTRP.annuitantYearlyPension = element.annualIncome ? element.annualIncome : 0;
          selectedProductQuoteFTRP.annuitantPension = element.annualIncome ? element.annualIncome / 12 : 0;
          selectedProductQuoteFTRP.annuitantMaturity = element.maturityValue ? element.maturityValue : 0;
          selectedProductQuoteFTRP.policyTerm = element.policyTerm ? element.policyTerm : 0;
          selectedProductQuoteFTRP.policyTermMonths = element.policyTermMonths ? element.policyTermMonths : 0;
          selectedProductQuoteFTRP.maturityAmount = element.maturityValue ? element.maturityValue : 0;
          selectedProductQuoteFTRP.initialAnnualIncome = element.annualIncome ? element.annualIncome : 0;
          selectedProductQuoteFTRP.giaCalculated = element.giaCalculated ? element.giaCalculated : null;
          selectedProductQuoteFTRP.requoteInd = element.requoteInd;
          selectedProductQuoteFTRP.applyQuoteInd = element.applyQuoteInd;
          selectedProductQuoteFTRP.fundingSource = element.source;
          //this.guaranteedQuoteResultArray.push(selectedProductQuoteFTRP);
          convertApiToObjectArray.push(selectedProductQuoteFTRP);
        } else if (element && element.product === 'G') {
          const selectedProductQuoteCORP = new SelectedProductQuoteCORP();
          selectedProductQuoteCORP.pensionFund = parseFloat(element.netAmount).toFixed(2);
          selectedProductQuoteCORP.productOptions = element.productOptions;
          selectedProductQuoteCORP.startDate = element.startDate;
          selectedProductQuoteCORP.income = CommonUtilityService.formatIncome(element.paymentFrequency, element.paymentAdvance);
          selectedProductQuoteCORP.incomeIncrease = CommonUtilityService.formatIncomeIncrease(element.escalationType, element.escalationRate);
          selectedProductQuoteCORP.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;;
          selectedProductQuoteCORP.incomeDependent = element.secondLifePensionPercentage ? element.secondLifePensionPercentage : 0;
          selectedProductQuoteCORP.guaranteedTerm = element.guaranteedTerm ? element.guaranteedTerm : 0;
          selectedProductQuoteCORP.guarantedPaymentPeriod = CommonUtilityService.formatGuarantedPaymentPeriod(element.guaranteedTerm);
          selectedProductQuoteCORP.valueProtection = element.vpPercentage;
          selectedProductQuoteCORP.valueProtectionAmount = element.vpAmount;
          selectedProductQuoteCORP.quoteExpiry = element.quoteExpiry;
          selectedProductQuoteCORP.monthlyIncome = element.annualIncome ? element.annualIncome / 12 : 0;
          selectedProductQuoteCORP.annualIncome = element.annualIncome;
          selectedProductQuoteCORP.padsRefNo = element.padsRefNo;
          selectedProductQuoteCORP.paymentFrequency = element.paymentFrequency;
          selectedProductQuoteCORP.selectedProduct = element.product;
          selectedProductQuoteCORP.quoteRefNo = element.quoteRefNo;
          selectedProductQuoteCORP.annuitantYearlyPension = element.annuitantYearlyPension ? element.annuitantYearlyPension : 0;
          selectedProductQuoteCORP.annuitantPension = element.annualIncome ? element.annualIncome / 12 : 0;
          selectedProductQuoteCORP.policyTerm = element.policyTerm ? element.policyTerm : 0;
          selectedProductQuoteCORP.policyTermMonths = element.policyTermMonths ? element.policyTermMonths : 0;
          selectedProductQuoteCORP.requoteInd = element.requoteInd;
          selectedProductQuoteCORP.applyQuoteInd = element.applyQuoteInd;
          selectedProductQuoteCORP.fundingSource = element.source;
          //this.guaranteedQuoteResultArray.push(selectedProductQuoteCORP);
          convertApiToObjectArray.push(selectedProductQuoteCORP);
        }
      }
    });
    return convertApiToObjectArray;
  }
  formatGuaranteedToObjectApplication(QuoteResultApi: any[]): Selectedproductquote[] {
    //console.log('1', QuoteResultApi);
    let convertApiToObjectApplicationArray: any[] = [];
    QuoteResultApi.forEach(element => {
      const taxFreeCashAmount = element.quoteResultModel.totalTaxFreeCashAmount || 0;
      const extTaxFreeCashAmount = element.quoteResultModel.totalExtTaxFreeCashAmount || 0;
      if(element.applicationId && this.applicationReferenceListing.includes(element.applicationId) == false) {
        this.applicationReferenceListing.push(element.applicationId)
      }
      if (element.quoteResultModel.isGMP === quoteLevelConstants.radioToggleYesNo.yes) {
        const selectedGMP = new SelectedGMPQuote();
        selectedGMP.isGMP = element.quoteResultModel.isGMP;
        selectedGMP.quoteRefNo = element.quoteResultModel.quoteRefNo;
        selectedGMP.padsRefNo = element.quoteResultModel.padsRefNo;
        selectedGMP.monthlyIncome = element.quoteResultModel.annualIncome ? element.quoteResultModel.annualIncome / 12 : 0;
        selectedGMP.annualIncome = element.quoteResultModel.annualIncome;
        selectedGMP.quoteExpiry = element.quoteResultModel.quoteExpiry;
        selectedGMP.pensionFund = parseFloat(element.quoteResultModel.pensionFund).toFixed(2);
        selectedGMP.startDate = element.quoteResultModel.startDate;
        selectedGMP.income = CommonUtilityService.formatIncome(element.quoteResultModel.paymentFrequency, element.quoteResultModel.paymentAdvance);
        selectedGMP.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
        selectedGMP.taxFreeCashAmountPercent = element.quoteResultModel.taxFreeCashAmountPercent;
        selectedGMP.requoteInd = element.quoteResultModel.requoteInd;
        selectedGMP.selectedProduct = element.quoteResultModel.product;
        selectedGMP.productOptions = element.quoteResultModel.productOptions;
        selectedGMP.indicative = element.quoteResultModel.indicative;
        selectedGMP.paymentFrequency = element.quoteResultModel.paymentFrequency;
        selectedGMP.fundingSource = element.quoteResultModel.source;
        selectedGMP.applicationId = element.applicationId;
        convertApiToObjectApplicationArray.push(selectedGMP);
      } else {
        if (element && element.quoteResultModel && element.quoteResultModel.product && element.quoteResultModel.product === 'C') {
          const selectedproductquote = new Selectedproductquote();
          selectedproductquote.pensionFund = (this.isGARCheck(element.quoteResultModel.garIndicator)) ?
            element.quoteResultModel.totalFund : parseFloat(element.quoteResultModel.netAmount).toFixed(2);
          selectedproductquote.productOptions = element.quoteResultModel.productOptions;
          selectedproductquote.startDate = element.quoteResultModel.startDate;
          selectedproductquote.income = CommonUtilityService.formatIncome(element.quoteResultModel.paymentFrequency, element.quoteResultModel.paymentAdvance);
          selectedproductquote.incomeIncrease = CommonUtilityService.formatIncomeIncrease(element.quoteResultModel.escalationType, element.quoteResultModel.escalationRate);
          selectedproductquote.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
          selectedproductquote.incomeDependent = element.quoteResultModel.secondLifePensionPercentage ? element.quoteResultModel.secondLifePensionPercentage : 0;
          selectedproductquote.guaranteedTerm = element.quoteResultModel.guaranteedTerm ? element.quoteResultModel.guaranteedTerm : 0;
          selectedproductquote.guarantedPaymentPeriod = CommonUtilityService.formatGuarantedPaymentPeriod(element.quoteResultModel.guaranteedTerm);
          selectedproductquote.valueProtection = element.quoteResultModel.vpPercentage;
          selectedproductquote.valueProtectionAmount = element.quoteResultModel.vpAmount;
          selectedproductquote.quoteExpiry = element.quoteResultModel.quoteExpiry;
          selectedproductquote.monthlyIncome = element.quoteResultModel.annualIncome ? element.quoteResultModel.annualIncome / 12 : 0;
          selectedproductquote.annualIncome = element.quoteResultModel.annualIncome;
          selectedproductquote.padsRefNo = element.quoteResultModel.padsRefNo;
          selectedproductquote.paymentFrequency = element.quoteResultModel.paymentFrequency;
          selectedproductquote.selectedProduct = element.quoteResultModel.product;
          selectedproductquote.quoteRefNo = element.quoteResultModel.quoteRefNo;
          selectedproductquote.fundingSource = element.quoteResultModel.source;
          selectedproductquote.applicationId = element.applicationId;
          selectedproductquote.garIndicator = element.quoteResultModel.garIndicator;
          selectedproductquote.taxFreeCashAmountPercent = element.quoteResultModel.taxFreeCashAmountPercent;
          selectedproductquote.vpIndicator = element.quoteResultModel.vpIndicator;
          //this.guaranteedQuoteResultArray.push(selectedproductquote);
          convertApiToObjectApplicationArray.push(selectedproductquote);
          //console.log('1', element);
          //console.log('2', element.quoteResultModel.product);
        } else if (element && element.quoteResultModel && element.quoteResultModel.product && element.quoteResultModel.product === 'H') {
          const selectedProductQuoteFTRP = new SelectedProductQuoteFTRP();
          selectedProductQuoteFTRP.pensionFund = element.quoteResultModel.netAmount;
          selectedProductQuoteFTRP.productOptions = element.quoteResultModel.productOptions;
          selectedProductQuoteFTRP.startDate = element.quoteResultModel.startDate;
          selectedProductQuoteFTRP.income = CommonUtilityService.formatIncome(element.quoteResultModel.paymentFrequency, element.quoteResultModel.paymentAdvance);
          selectedProductQuoteFTRP.incomeIncrease = CommonUtilityService.formatIncomeIncrease(element.quoteResultModel.escalationType, element.quoteResultModel.escalationRate);
          selectedProductQuoteFTRP.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
          selectedProductQuoteFTRP.incomeDependent = element.quoteResultModel.secondLifePensionPercentage ? element.quoteResultModel.secondLifePensionPercentage : 0;
          selectedProductQuoteFTRP.guaranteedTerm = element.quoteResultModel.guaranteedTerm ? element.quoteResultModel.guaranteedTerm : 0;
          selectedProductQuoteFTRP.guaranteedTermIndicator = element.quoteResultModel.guaranteedTermIndicator ? element.quoteResultModel.guaranteedTermIndicator : null;
          selectedProductQuoteFTRP.guarantedPaymentPeriod = CommonUtilityService.formatGuarantedPaymentPeriod(element.quoteResultModel.guaranteedTerm);
          selectedProductQuoteFTRP.valueProtection = element.quoteResultModel.vpPercentage;
          selectedProductQuoteFTRP.valueProtectionAmount = element.quoteResultModel.vpAmount;
          selectedProductQuoteFTRP.quoteExpiry = element.quoteResultModel.quoteExpiry;
          selectedProductQuoteFTRP.monthlyIncome = element.quoteResultModel.annuitantPension ? element.quoteResultModel.annuitantPension : 0;
          selectedProductQuoteFTRP.annualIncome = element.quoteResultModel.annualIncome;
          selectedProductQuoteFTRP.padsRefNo = element.quoteResultModel.padsRefNo;
          selectedProductQuoteFTRP.paymentFrequency = element.quoteResultModel.paymentFrequency;
          selectedProductQuoteFTRP.selectedProduct = element.quoteResultModel.product;
          selectedProductQuoteFTRP.quoteRefNo = element.quoteResultModel.quoteRefNo;
          selectedProductQuoteFTRP.annuitantYearlyPension = element.quoteResultModel.annualIncome ? element.quoteResultModel.annualIncome : 0;
          selectedProductQuoteFTRP.annuitantPension = element.quoteResultModel.annualIncome ? element.quoteResultModel.annualIncome / 12 : 0;
          selectedProductQuoteFTRP.annuitantMaturity = element.quoteResultModel.maturityValue ? element.quoteResultModel.maturityValue : 0;
          selectedProductQuoteFTRP.policyTerm = element.quoteResultModel.policyTerm ? element.quoteResultModel.policyTerm : 0;
          selectedProductQuoteFTRP.policyTermMonths = element.quoteResultModel.policyTermMonths ? element.quoteResultModel.policyTermMonths : 0;
          selectedProductQuoteFTRP.maturityAmount = element.quoteResultModel.maturityValue ? element.quoteResultModel.maturityValue : 0;
          selectedProductQuoteFTRP.initialAnnualIncome = element.quoteResultModel.annualIncome ? element.quoteResultModel.annualIncome : 0;
          selectedProductQuoteFTRP.giaCalculated = element.quoteResultModel.giaCalculated ? element.quoteResultModel.giaCalculated : null;
          selectedProductQuoteFTRP.fundingSource = element.quoteResultModel.source;
          selectedProductQuoteFTRP.applicationId = element.applicationId;
          //this.guaranteedQuoteResultArray.push(selectedProductQuoteFTRP);
          convertApiToObjectApplicationArray.push(selectedProductQuoteFTRP);
        } else if (element && element.quoteResultModel && element.quoteResultModel.product && element.quoteResultModel.product === 'G') {
          const selectedProductQuoteCORP = new SelectedProductQuoteCORP();
          selectedProductQuoteCORP.pensionFund = element.quoteResultModel.netAmount;
          selectedProductQuoteCORP.productOptions = element.quoteResultModel.productOptions;
          selectedProductQuoteCORP.startDate = element.quoteResultModel.startDate;
          selectedProductQuoteCORP.income = CommonUtilityService.formatIncome(element.quoteResultModel.paymentFrequency, element.quoteResultModel.paymentAdvance);
          selectedProductQuoteCORP.incomeIncrease = CommonUtilityService.formatIncomeIncrease(element.quoteResultModel.escalationType, element.quoteResultModel.escalationRate);
          selectedProductQuoteCORP.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
          selectedProductQuoteCORP.incomeDependent = element.quoteResultModel.secondLifePensionPercentage ? element.quoteResultModel.secondLifePensionPercentage : 0;
          selectedProductQuoteCORP.guaranteedTerm = element.quoteResultModel.guaranteedTerm ? element.quoteResultModelguaranteedTerm : 0;
          selectedProductQuoteCORP.guarantedPaymentPeriod = CommonUtilityService.formatGuarantedPaymentPeriod(element.quoteResultModel.guaranteedTerm);
          selectedProductQuoteCORP.valueProtection = element.quoteResultModel.vpPercentage;
          selectedProductQuoteCORP.valueProtectionAmount = element.quoteResultModel.vpAmount;
          selectedProductQuoteCORP.quoteExpiry = element.quoteResultModel.quoteExpiry;
          selectedProductQuoteCORP.monthlyIncome = element.quoteResultModel.annualIncome ? element.quoteResultModel.annualIncome / 12 : 0;
          selectedProductQuoteCORP.annualIncome = element.quoteResultModel.annualIncome;
          selectedProductQuoteCORP.padsRefNo = element.quoteResultModel.padsRefNo;
          selectedProductQuoteCORP.paymentFrequency = element.quoteResultModel.paymentFrequency;
          selectedProductQuoteCORP.selectedProduct = element.quoteResultModel.product;
          selectedProductQuoteCORP.quoteRefNo = element.quoteResultModel.quoteRefNo;
          selectedProductQuoteCORP.annuitantYearlyPension = element.quoteResultModel.annuitantYearlyPension ? element.quoteResultModel.annuitantYearlyPension : 0;
          selectedProductQuoteCORP.annuitantPension = element.quoteResultModel.annualIncome ? element.quoteResultModel.annualIncome / 12 : 0;
          selectedProductQuoteCORP.policyTerm = element.quoteResultModel.policyTerm ? element.quoteResultModel.policyTerm : 0;
          selectedProductQuoteCORP.policyTermMonths = element.quoteResultModel.policyTermMonths ? element.quoteResultModel.policyTermMonths : 0;
          selectedProductQuoteCORP.fundingSource = element.quoteResultModel.source;
          selectedProductQuoteCORP.applicationId = element.applicationId;
          //this.guaranteedQuoteResultArray.push(selectedProductQuoteCORP);
          convertApiToObjectApplicationArray.push(selectedProductQuoteCORP);
        }
      }
    });
    return convertApiToObjectApplicationArray;
  }
  formatPartialToObject() {
    this.partialQuoteResultArray = [];
    this.partialQuoteResultApi.forEach(element => {
      const partialproductquote = new Partialproductquote();
      partialproductquote.pensionFund = parseFloat(element.netAmount).toFixed(2);
      partialproductquote.commencementDate = element.commencementDate || element.creationDate;
      partialproductquote.quoteDateFlag = (element.commencementDate && element.commencementDate.length !== 0) ? true : false;
      partialproductquote.selectedProduct = element.product ? (this.cmsDataProductChoice.products.find(p =>
        p.productCode === element.product).productName) : element.product;
      partialproductquote.quoteRefNo = element.quoteRefNo;
      partialproductquote.selectedProductCode = element.product;
      partialproductquote.fundingSource = element.source;
      if(element['quoteRefNo'] && this.internalReferenceDCJListing.includes(element['quoteRefNo']) == false) {
        this.internalReferenceDCJListing.push(element['quoteRefNo'])
      }
      this.partialQuoteResultArray.push(partialproductquote);
    });
  }

  formatIndicativeToObject(QuoteResultApi: any[]): Selectedproductquote[] {

    let convertApiToObjectArray: any[] = [];
    QuoteResultApi.forEach(element => {
      const taxFreeCashAmount = element.totalTaxFreeCashAmount || 0;
      const extTaxFreeCashAmount = element.totalExtTaxFreeCashAmount || 0;
      if(element['quoteRefNo'] && this.internalReferenceDCJListing.includes(element['quoteRefNo']) == false) {
        this.internalReferenceDCJListing.push(element['quoteRefNo'])
      }
      if(element['padsRefNo'] && this.quoteReferenceListing.includes(element['padsRefNo']) == false) {
        this.quoteReferenceListing.push(element['padsRefNo'])
      }
      if (element.isGMP === quoteLevelConstants.radioToggleYesNo.yes) {
        const selectedGMP = new SelectedGMPQuote();
        selectedGMP.isGMP = element.isGMP;
        selectedGMP.quoteRefNo = element.quoteRefNo;
        selectedGMP.padsRefNo = element.padsRefNo;
        selectedGMP.monthlyIncome = element.annualIncome ? element.annualIncome / 12 : 0;
        selectedGMP.annualIncome = element.annualIncome;
        selectedGMP.quoteExpiry = element.quoteExpiry;
        selectedGMP.pensionFund = parseFloat(element.pensionFund).toFixed(2);
        selectedGMP.startDate = element.startDate;
        selectedGMP.income = CommonUtilityService.formatIncome(element.paymentFrequency, element.paymentAdvance);
        selectedGMP.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
        selectedGMP.taxFreeCashAmountPercent = element.taxFreeCashAmountPercent;
        selectedGMP.requoteInd = element.requoteInd;
        selectedGMP.selectedProduct = element.product;
        selectedGMP.productOptions = element.productOptions;
        selectedGMP.indicative = element.indicative;
        selectedGMP.paymentFrequency = element.paymentFrequency;
        selectedGMP.fundingSource = element.source;
        convertApiToObjectArray.push(selectedGMP);
      } else {
        const indicativequote = new Selectedproductquote();
        indicativequote.pensionFund = this.isGARCheck(element.garIndicator) ? element.totalFund : element.netAmount;
        indicativequote.startDate = element.startDate;
        indicativequote.income = CommonUtilityService.formatIncome(element.paymentFrequency, element.paymentAdvance);
        indicativequote.incomeIncrease = CommonUtilityService.formatIncomeIncrease(element.escalationType, element.escalationRate);
        indicativequote.totalTaxFreeCashAmount = taxFreeCashAmount + extTaxFreeCashAmount;
        indicativequote.incomeDependent = element.secondLifePensionPercentage ? element.secondLifePensionPercentage : 0;
        indicativequote.guaranteedTerm = element.guaranteedTerm ? element.guaranteedTerm : 0;
        indicativequote.guarantedPaymentPeriod = CommonUtilityService.formatGuarantedPaymentPeriod(element.guaranteedTerm);
        indicativequote.valueProtection = element.vpPercentage;
        indicativequote.valueProtectionAmount = element.vpAmount;
        indicativequote.quoteExpiry = element.quoteExpiry,
        indicativequote.monthlyIncome = element.annualIncome ? element.annualIncome / 12 : 0,
        indicativequote.annualIncome = element.annualIncome,
        indicativequote.padsRefNo = element.padsRefNo,
        indicativequote.paymentFrequency = element.paymentFrequency,
        indicativequote.selectedProduct = element.product,
        indicativequote.quoteRefNo = element.quoteRefNo,
        indicativequote.indicative = element.indicative,
        indicativequote.requoteInd = element.requoteInd,
        indicativequote.applyQuoteInd = element.applyQuoteInd,
          //console.log(indicativequote);
        indicativequote.productOptions = element.productOptions;
        indicativequote.garIndicator = element.garIndicator;
        indicativequote.taxFreeCashAmountPercent = element.taxFreeCashAmountPercent;
        indicativequote.vpIndicator = element.vpIndicator;
        indicativequote.fundingSource = element.source;
        convertApiToObjectArray.push(indicativequote);
      }
      //this.indicativeQuoteResultArray.push(indicativequote);
    });
    return convertApiToObjectArray;
  }

  getAnotherQuote() {
    this.router.navigate(['home']);
  }
  // Triggeres on click of CancelApplication button on tile
  cancelApplication(customerId: string, applicationId: string) {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'cancel application', pageID: this.getCurrentScreenURL(), applicationReferenceNo: applicationId });
    this.applicationId = applicationId;
    this.displayCancelAlert = true;
  }
  // Triggeres on click of ResumeApplication button on tile
  resumeApplication(applicationId: string, quoteExpiry: number, quoteRefNo: string) {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'resume', pageID: this.getCurrentScreenURL(), applicationReferenceNo: applicationId });
    this.applicationId = applicationId;
    if (quoteExpiry === 0) {
      this.displayResumeAlert = true;
    } else {
      this.resumeAlertSecondaryBtnClick(applicationId, quoteRefNo);
    }

  }
  viewQuote(quoteRefNo: string) {
    this.viewQuoteFlag = true;
    // DTC-295 Req : Resume method is triggered inorder to restore all quote journey data
    // this.ResumeQuote(quoteRefNo);
    this.quoteDatacaptureService.getGuaranteedQuote(quoteRefNo).subscribe(res => {
      this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
      this.store.dispatch(new quoteResultActions.AddQuoteResult(res));
      this.router.navigate(['/quote/your-product-quote'], { replaceUrl: true });
    });
  }
  reQuote(quoteRefNo: string, selectedProduct: string, productOptions: string) {
    this.requoteRefNum = quoteRefNo;
    if (!productOptions || productOptions.split(',').length <= 1) {
      this.alertPrimaryRequoteBtnClick();
    } else {
      let selectedProductName = '';
      let secondButtonText = '';
      if (this.CMSDataNewQuoteData) {
        if (selectedProduct === 'C') {
          selectedProductName = this.CMSDataNewQuoteData.stringGroup_NewQuotePACTALabel1;
          secondButtonText = this.CMSDataNewQuoteData.stringGroup_NewQuotePACTALabel2;
        } else if (selectedProduct === 'H') {
          selectedProductName = this.CMSDataNewQuoteData.stringGroup_NewQuoteFTRPCTALabel1;
          secondButtonText = this.CMSDataNewQuoteData.stringGroup_NewQuoteFTRPCTALabel2;
        } else {
          selectedProductName = this.CMSDataNewQuoteData.stringGroup_NewQuoteCORPCTALabel1;
          secondButtonText = this.CMSDataNewQuoteData.stringGroup_NewQuoteCORPCTALabel2;
        }
      }
      //alert("not implemented");
      //let selectedProductName = this.cmsDataProductChoice.products.find(p => p.productCode === selectedProduct).productName;

      // const secondButtonText = this.anotherProductSecBtntext(selectedProduct);

      this.contentData.modalConfigReQuote['footerPrimaryBtnLabel'] = 'productname';
      this.contentData.modalConfigReQuote['footerSecondaryBtnLabel'] = 'productname';
      this.contentData.modalConfigReQuote['footerPrimaryBtnLabel'] = this.contentData.modalConfigReQuote['footerPrimaryBtnLabel'].replace('productname', selectedProductName);
      this.contentData.modalConfigReQuote['footerSecondaryBtnLabel'] = this.contentData.modalConfigReQuote['footerSecondaryBtnLabel'].replace('productname', secondButtonText);
      this.displayAlertRequote = true;
    }


  }
  // 819US changes
  requoteExpiry(quoteRefNo: string) {
    this.requoteRefNum = quoteRefNo;
    this.quoteDatacaptureService.reQuote(this.requoteRefNum).subscribe(res => {
      this.quote = res;
      res['currentScreen'] = 'Option & Quote';
      this.utilService.restoreAllStore(this.requoteRefNum, false, false, this.quote, this.resposeJsonLoggedInDetailStore);
    });
  }
  alertPrimaryRequoteBtnClick() {
    this.quoteDatacaptureService.reQuote(this.requoteRefNum).subscribe(res => {
      this.quote = res;
      this.quote['currentScreen'] = 'Option & Quote';
      this.utilService.restoreAllStore(this.requoteRefNum, false, false, this.quote, this.resposeJsonLoggedInDetailStore);
      this.closeModal();
    });

  }
  alertSecondaryRequoteBtnClick() {
    // alert("not implemented");
    //this.displayAlertRequote=false;
    this.quoteDatacaptureService.reQuote(this.requoteRefNum).subscribe(res => {
      this.quote = res;
      this.quote['currentScreen'] = 'productChoice';
      this.closeModal();
      this.utilService.restoreAllStore(this.requoteRefNum, false, true, this.quote, this.resposeJsonLoggedInDetailStore);
    });
  }
  ResumeQuote(quoteRefNo: string) {
    this.quoteDatacaptureService.resumeQuote(quoteRefNo).subscribe(res => {
      // this.partialQuoteResultApi = res['partialQuotes'];
      this.quote = res;
      if (this.viewQuoteFlag) {
        // This condition happens click of View Quote in Quote Results Screen
        this.quote.currentScreen = 'your-product-quote';
        this.viewQuoteFlag = false;
      }
      //this.restoreAllStore(quoteRefNo, true, false);
      this.utilService.restoreAllStore(quoteRefNo, true, false, this.quote, this.resposeJsonLoggedInDetailStore);
    });

  }
  openPersonalisedQuote = (productQuote, type?: string) => {
    if (this.loginDetail && this.loginDetail.customer) {
      if (!type) {
        this.loadingPDFFlag = true;
        this.loadingFlag = false;
      } else {
        this.loadingFlag = true;
        this.loadingPDFFlag = false;
      }
      const customerDetail = this.loginDetail.customer;
      const recipientName = (customerDetail.title ? customerDetail.title + ' ' : '') +
        (customerDetail.forename ? customerDetail.forename + ' ' : '') +
        (customerDetail.middleName ? customerDetail.middleName + '  ' : '') +
        (customerDetail.surname ? customerDetail.surname : '');
      const inputParam = {
        addressLine1: customerDetail.address ? customerDetail.address.line1 : '',
        addressLine2: customerDetail.address ? customerDetail.address.line2 : '',
        addressLine3: customerDetail.address ? customerDetail.address.line3 : '',
        addressLine4: customerDetail.address ? customerDetail.address.line4 : '',
        countryCode: customerDetail.address ? customerDetail.address.countryCode : '',
        lifeTimeAllowanceFlag: 'N',
        isSendToTrustee: 'N',
        thirdParty: { partyType: '', address: {} },
        outputMethod: this.contentData.localPrint,
        packCode: '',
        packCodeDescription: '',
        padsRefNo: (productQuote && productQuote.padsRefNo) ?
          productQuote.padsRefNo : '',
        quoteRef: (productQuote && productQuote.quoteRefNo) ?
          productQuote.quoteRefNo : '',
        postcode: customerDetail.address ? customerDetail.address.postcode : '',
        recipientName,
        isGMP: quoteLevelConstants.radioToggleYesNo.no
      };
      this.outputDetailsService.generateRiskWarning(inputParam).subscribe((data: any) => {
        // this.successMessage = true;
        if (data) {
          this.applyFlag = true;
        } else {
          this.applyFlag = false;
          this.displayAlert = true; //
        }
        this.buttonService.handleButtonLoaderFlag({ flag: false });
        if (this.loadingFlag) {
          this.loadingFlag = false;
        }
        if (this.loadingPDFFlag) {
          this.loadingPDFFlag = false;
        }
        const file = new Blob([data], { type: 'application/pdf' });

        const nav = (window.navigator as any); 

        if (nav.msSaveOrOpenBlob) {
          nav.msSaveOrOpenBlob(file, 'Quote ref' + productQuote.padsRefNo + '.pdf');
          // if (this.lifeTimeAllowanceFlag != null && this.lifeTimeAllowanceFlag === 'Y') {
          //   nav.msSaveOrOpenBlob(file, 'Quote ref' + quoteRequestSearchModelsWithoutLCP[i].quoteResultModel.padsRefNo
          //     + ' ' + 'Z32.pdf');
          // }
          // else {
          //   nav.msSaveOrOpenBlob(file, 'Quote ref' + quoteRequestSearchModelsWithoutLCP[i].quoteResultModel.padsRefNo
          //     + ' ' + quoteRequestSearchModelsWithoutLCP[i].packCode + '.pdf');
          // }
        } else {
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.applyFlag = true;
          this.displayAlert = false;
        }
        if (type && type === 'downloadAll') {
          window.open(this.pdfUrlArray[0], '_blank');
          window.open(this.pdfUrlArray[1], '_blank');
          window.open(this.pdfUrlArray[2], '_blank');
        }
        this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
      }, (err: HttpErrorResponse) => {
        this.applyFlag = false;
        this.displayAlert = true;
        this.loadingPDFFlag = false;
        if (err.error instanceof Error) {
          this.buttonService.handleButtonLoaderFlag({ flag: false });
          this.loadingFlag = false;
          //console.log('Client-side error occured.');
        } else {
          //console.log(err);
          this.buttonService.handleButtonLoaderFlag({ flag: false });
          this.loadingFlag = false;
          // this.successMessage = false;
          // this.store.dispatch({ type: 'LOADING_ICON', loadingIcon: false });
        }
      });
    }
  }

  // handleCustomEvent(event: CustomEvent) {
  //   // console.log('Custom event received:', event.detail.message);

  //   // Your existing code to handle the PDF download

  //     var link = document.createElement('a');
  //     link.href = event.detail.fileURL;
  //     link.target = '_blank'; // Open in new tab
  //     // link.download = 'Quote ref' + event.detail.productQuote.padsRefNo + '.pdf';
  //     // document.body.appendChild(link);
  //     link.click();
  //     link = null;
  //     // document.body.removeChild(link);
    
  //   // URL.revokeObjectURL(event.detail.fileURL);
  // }

  resumeAlertPrimaryBtnClick() {
    this.displayResumeAlert = false;
  }

  resumeGuidanceAndAdvice() {
    const screen = "guidanceAndAdvice";
    this.utilService.popUpGuidanceAndAdvice$.next("")
    this.router.navigate([this.utilService.getScreenName(screen)]);
  }
  cancelAlertPrimaryBtnClick(applicationId: string) {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'no, return to quote dashboard', pageID: this.getCurrentScreenURL(), applicationReferenceNo: applicationId });
    this.applicationId = applicationId;
    this.cancelCloseModal();
  }
  // makes backend call for cancelling application
  cancelAlertSecondaryBtnClick(customerId: string, applicationId: string) {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'yes, cancel this application', pageID: this.getCurrentScreenURL(), applicationReferenceNo: applicationId });
    this.displayCancelAlert = false;
    this.applicationDataCaptureService.cancelApplication(customerId, applicationId).subscribe(res => {
      this.data(res);
    });
  }
  // makes backend call for resuming application
  resumeAlertSecondaryBtnClick(applicationId: string, quoteRefNo: string) {
    this.displayResumeAlert = false;
    // DTC-295 Req : Resume method is triggered inorder to restore all quote journey data
    // this.ResumeQuote(quoteRefNo);
    /* this line of code is to store the application id into refNo store when clicking on Resume CTA */
    this.applicationDataCaptureService.resumeApplication(applicationId, 'DCJ').subscribe(res => {
      this.store.dispatch(new RefNoActions.RemoveReferenceNumber(0));
      this.store.dispatch(new RefNoActions.AddReferenceNumber({
        editMode: false,
        formSessionId: res['formSessionId'],
        quoteNumberFlag: 1,
        quoteReferenceNumber: null,
        applicationRefNumber: res['applicationId']
      }));
      this.application = res;
      this.restoreApplyData(this.application, applicationId);
      // this.utilService.restoreAllApplicationStore(applicationId, true, false, this.application, this.resposeJsonLoggedInDetailStore);
    });
  }
  cancelCloseModal() {
    this.displayCancelAlert = false;
  }
  closeModal() {
    this.displayAlertRequote = false;
  }
  resumeCloseModal() {
    this.displayResumeAlert = false;
  }
  public getScreenName(currentscreen): string {
    const breadcrumbDetails = BreadCrumDataConfig.BreadcrumbConfig.data.values;
    return breadcrumbDetails.find(br => br['screenName'] === currentscreen).path;
  }
  public getScreenNameID(currentscreen): number {
    const breadcrumbDetails = BreadCrumDataConfig.BreadcrumbConfig.data.values;
    return breadcrumbDetails.find(br => br['screenName'] === currentscreen).id;
  }

  anotherProductSecBtntext(seletedProduct: string): string {
    if (seletedProduct === 'C') {
      return this.contentData.fixedTermOrCashOut;
      //'Fixed Term or Cash Out';
    } else if (seletedProduct === 'H') {
      return this.contentData.pensionAnnuityOrCashOut;
    } else {
      return this.contentData.pensionAnnuityOrFixedTerm;
    }
  }
  ngOnDestroy() {
    if (this.subscriptionLogin) {
      this.subscriptionLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
  }

  GetCMSGuidanceAndAdviceModal() {
    const URL = SERVICE_END_POINT.higherEnvironment.CMS_GuidanceAndAdvice;
    this.utilService.getCMSData(URL)
      .subscribe(res => {
        if (res) {
          this.contentData.GuidanceANdAdviceModalConfig.header = res?.string_ImportantInformation;
          this.contentData.GuidanceANdAdviceModalConfig.content = res?.string_ImportantInformationWording;
        }
      });
  }

  /** Code block for CMS */
  GetCMSDataServiceMapper() {
    if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.applicationProgressText = this.CMSData.string_InProgressSubtitle;
      this.contentData.guaranteedquotesHeader = this.CMSData.string_GuaranteedTitle;
      this.contentData.guaranteedquotesText = this.CMSData.string_GuaranteedSubtitle;
      //this.contentData.contentData.yourSaveQuotetext = this.CMSData.
      this.contentData.btnResumeQuote = this.CMSData.string_ResumeCTALabel;
      this.contentData.applicationProgressHeader = this.CMSData.string_AppInProgressTitle;
      this.contentData.applicationProgressText = this.CMSData.string_AppInProgressSubtitle;
      this.contentData.btnViewQuote = this.CMSData.string_ViewQuoteCTALabel;
      this.contentData.progressQuoteText = this.CMSData.string_InProgressSubtitle;
      this.contentData.btnCancelApplication = this.CMSData.string_CancelAppCTALabel;
      this.contentData.applicationSubmitedHeader = this.CMSData.string_AppSubmittedTitle;
      this.contentData.applicationSubmittedText = this.CMSData.string_AppSubmittedSubtitle;
      // this.contentData.btnViewApplication = this.CMSData.string_ViewApplicationCTALabel;
      this.contentData.invalidateGuaranteedquotesHeader = this.CMSData.string_InvalidTitle;
      this.contentData.invalidguarantedCodeText = this.CMSData.string_InvalidSubtitle;
      this.contentData.expiredQuotesHeader = this.CMSData.string_ExpiredTitle;
      this.contentData.expiredQuotesText = this.CMSData.string_ExpiredSubtitle;
      this.contentData.btnRefreshQuote = this.CMSData.string_RefreshCTALabel;
      this.contentData.indicativequotesText = this.CMSData.string_IndicativeSubtitle;
      this.contentData.btnGetanotherquote = this.CMSData.string_GetANewQuoteCTALabel;
      this.contentData.btnRequote = this.CMSData.string_GetANewQuoteCTALabel;
      this.contentData.indicativeQuoteHeader = this.CMSData.string_IndicativeTitle;
      this.contentData.invalidateGuaranteedquotesText = this.CMSData.string_InvalidSubtitle;
    }
  }
  GetCMSDataServiceMapperCancelApp() {
    if (this.CMSDataCancelApp) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.modalConfigCancelApplication.header = this.CMSDataCancelApp.string_CancelAppPopUpMessageTitle;
      this.contentData.modalConfigCancelApplication.content = this.CMSDataCancelApp.string_CancelAppPopUpMessageText;
      this.contentData.modalConfigCancelApplication.footerPrimaryBtnLabel = this.CMSDataCancelApp.string_CancelAppPopUpCTALabel1;
      this.contentData.modalConfigCancelApplication.footerSecondaryBtnLabel = this.CMSDataCancelApp.string_CancelAppPopUpCTALabel2;
    }
  }

  GetCMSDataServiceMapperAppQuoteExpiry() {
    if (this.CMSDataQuoteExp) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.modalConfigResumeApplication.header = this.CMSDataQuoteExp.string_AppQuoteExpMessageTitle;
      this.contentData.modalConfigResumeApplication.content = this.CMSDataQuoteExp.string_AppQuoteExpText;
      this.contentData.modalConfigResumeApplication.footerPrimaryBtnLabel = this.CMSDataQuoteExp.string_AppQuoteExpCTALabel1;
      this.contentData.modalConfigResumeApplication.footerSecondaryBtnLabel = this.CMSDataQuoteExp.string_AppQuoteExpCTALabel2;
    }
  }

  GetCMSDataServiceMapperNewQuoteModal() {
    if (this.CMSDataNewQuoteData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.modalConfigReQuote.header = this.CMSDataNewQuoteData.string_NewQuotePopUpMessageTitle;
      this.contentData.modalConfigReQuote.content = this.CMSDataNewQuoteData.string_NewQuotePopUpMessageText;
    }
  }
  /** End of code block for CMS */
  /** For web tracking */
  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);

    return this.screenName;
  }
  // defect #3159 - 'View Application' CTA functionality
  viewApplication(applicationId: any) {
    this.applicationDataCaptureService.viewApplication(applicationId).subscribe(res => {
      this.application = res;
      if (res) {
        this.application['currentScreen'] = 'your-product-application';
      }
      this.restoreApplyData(this.application, applicationId, true);
    });
  }
  restoreApplyData(applicationData, applicationId, isViewApplication = false) {
    if (applicationData) {
      // get quoteData from backend and capture it in a store
      this.quoteDatacaptureService.getGuaranteedQuote(applicationData.quoteRefs[0]).subscribe(res => {
        this.store.dispatch(new quoteResultActions.RemoveQuoteResult(0));
        this.store.dispatch(new quoteResultActions.AddQuoteResult(res));
        this.applicationDataCaptureService.displayGMPBC(applicationData, res);
      });
      // tslint:disable-next-line: max-line-length
      this.utilService.restoreAllApplicationStore(applicationId, true, false, applicationData, this.resposeJsonLoggedInDetailStore, isViewApplication);
    }
  }
  isGARCheck(garIndicator: string) {
    if (garIndicator === quoteLevelConstants.garIndicators.yes || garIndicator === quoteLevelConstants.garIndicators.ignored
      || garIndicator === quoteLevelConstants.garIndicators.beaten || garIndicator === quoteLevelConstants.garIndicators.featured) {
      return true;
    }
    return false;
  }

  getSlocWarningText(quoteOrApply: string) {
    if (quoteOrApply && quoteOrApply === 'A') {
      return this.contentData.slocWarningMessage.replace('quote.', 'application.');
    } else {
      return this.contentData.slocWarningMessage;
    }
  }
}
